import { configJson, getHttp} from "./config/http-configs";


export const getFields = () => {
    const url = '/mobile/apply/form/info/BOOK_APPLY'
    return getHttp().get(url)
}

export const addApply = (apply) => {
    return getHttp().post('/mobile/apply/add', apply, configJson)
}

export const searchEmployee = (searchData) => {
    let url = '/mobile/employee/search'
    return getHttp().post(url, searchData, configJson)
}

export const visitorAdd = (name, tel, company, idCardNo) => {
    const url = "/mobile/visitor/company/add"
    const postData = {name, tel, company, ic: idCardNo}
    return getHttp().post(url, postData, configJson)
}
